/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import PanelTabs from "../../../components/Shared/Tab/PanelTabs";
import { ITabItems } from "../../../components/Shared/Tab/types";
import DebugLogs from "../../../components/Configuration/Files/DebugLogs";
import PMFiles from "../../../components/Configuration/Files/PMFiles";
import ErrorBundles from "../../../components/Configuration/Files/ErrorBundles";
import Cper from "../../../components/Configuration/Files/Cper";
import DBBackup from "../../../components/Configuration/Files/DBBackup";

const Files: React.FC = () => {
  const tabData: Array<ITabItems> = [
    {
      label: "Debug Logs",
      component: <DebugLogs />,
    },
    {
      label: "PM Files",
      iconPosition: "end",
      component: <PMFiles />,
    },
    {
      label: "Error Bundles",
      component: <ErrorBundles />,
    },
    {
      label: "CPER",
      component: <Cper />,
    },
    {
      label: "DB Backups",
      component: <DBBackup />,
    },
  ];
  return (
    <div
      style={{
        minHeight: "500px",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius)",
        boxShadow: "var(--shadow-card)",
        backgroundColor: "var(--card)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", padding: "16px", overflow: "auto" }}>
        <PanelTabs tabData={tabData} />
      </div>
    </div>
  );
};

export default Files;
